import script from "./MergeVideoSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./MergeVideoSettings.vue?vue&type=script&setup=true&lang=ts"

import "./MergeVideoSettings.vue?vue&type=style&index=0&id=0c9ccccb&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c9ccccb"]])

export default __exports__